import {
	useFilteredClientMetricProgressData,
	useAggregatedMetricProgress,
	useAddDataModalToggle,
	useMetriceCategories
} from './hooks'
import {
	setFilters
} from './slice'
import {useState,useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {
	useClient,
	useClients
} from '../users/hooks'
import PrintableProgressGraph from './PrintableProgressGraph'
import ProgressGraph from './ProgressGraph'
import ProgressTable from './ProgressTable'
import UserThumbnail from '../UserThumbnail/UserThumbnail'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import Form from 'react-bootstrap/Form'
import {Link,useHistory} from 'react-router-dom'
import DateRangeOptions from './DateRangeOptions'
import AddDataModal from './AddDataModal'
import Select from 'react-select'
import css from './Metrics.module.css'
import useCurrentUser from '../../hooks/useCurrentUser'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover'
import Table from 'react-bootstrap/Table'
import KeypointLogViewer from '../AIDemo/KeypointLogViewer'

const LogsViewer = ({aiLogs,size,demo})=>{

	const [currentLogIdx,setCurrentLogIdx] = useState(0)
	const logOptions = aiLogs
	.sort((a,b)=>(a.date<b.date?-1:1))
	.map(({date},i)=>({
		label:date,
		value:i
	}))

	if (aiLogs.length === 0) return null

	const aiLog = aiLogs[currentLogIdx]

	return (
		<div>
			<Select
				onChange={({value})=>setCurrentLogIdx(value)}
				value={{
					label:aiLog.date,
					value:currentLogIdx
				}}
				options={logOptions}
			/>
			<KeypointLogViewer 
				size={size}
				demo={demo}
				id={aiLog.id}
				results={aiLog.results}
			/>
		</div>
	)
}

const AggregateGrid = ()=>{
	const user = useCurrentUser()
	const dispatch = useDispatch()
	const history = useHistory()

	//displayFormat = chart | table
	const [displayFormat,setDisplayFormat] = useState('graph')

	const {
		status:clientsStatus,
		clients
	} = useClients()

	const monthsOptions = [3,6,9,12]

	const [months,setMonths] = useState(3)

	const {status,data} = useAggregatedMetricProgress(months)


	const categories = useMetriceCategories()

	const handleChangeCategoryFilter = e => {
		dispatch(setFilters({category:e.target.value}))
	}

	const [printing,setPrinting] = useState(false)

	const handlePrint = () => {
		setPrinting(true)
		setTimeout(()=>{
			window.print()
			setPrinting(false)
		})
	}

	const toggleAddDataModal = useAddDataModalToggle()

	//map from category names to the coresponding
	//ai demo key
	const categoryNameAiDemoKeyMap = {
		'AI Knee Flexion Measurements':'knee-flexion',
		'AI Single Leg Balance Assessment':'balance',
		'AI Single Leg Squat Assessment':'single-leg-squat',
		'AI Squat Assessment':'squat',
		'AI Overhead Arm Mobility':'arm-overhead-movement'
	}

	return (
		<div style={{
			width:'100%',
			height:'100%',
			overflow:'hidden',
			display:'flex',
			flexFlow:'column',
			alignItems:'stretch'
		}}>
			<div style={{paddingBottom:'8px',borderBottom:'1px solid #ccc'}} className="pt-2 px-2 px-md-3">
				<div className="d-flex justify-content-between align-items-end flex-wrap">
					{user.account_type!=='client'&&
						<div className="d-flex align-items-center">
							<div>
								<small>Client Name</small>
								<div style={{width:'200px'}}>
									<Select
										onChange={selected=>{
											history.replace(`/metric-graphs/?clientId=${selected.value}`)
										}}
										value={{label:'All Clients',value:'all'}}
										options={[
											{
												label:'All Clients',
												value:'all'
											},
											...clients.map(c=>({
												label:c.user_name,
												value:c.user_id_number
											}))
										]}
									/>
								</div>
							</div>
						</div>
					}
					<ButtonGroup
						size="sm"
					>
						{monthsOptions.map(m=>(
							<Button 
								variant={m===months?'primary':"outline-primary"}
								onClick={setMonths.bind(null,m)}
							>
								{m} Months
							</Button>
						))}
					</ButtonGroup>
				</div>
			</div>
			<div style={{
				height:'100%',
				overflow:'auto',
				paddingBottom:'200px',
				padding:'16px'
			}}>
				{status!=='idle'
					?<Spinner animation="border"/>
					: (
						<Table striped size="sm">
							<thead>
								<tr>
									<th colSpan={2}>Percent of clients that made an improvement in the past {months} months</th>
								</tr>
								<tr>
									<th>Metric</th>
									<th>% of Clients</th>
								</tr>
							</thead>
							<tbody>
								{data.improved.map(({metric,percent})=>(
									<tr>
										<td>{metric}</td>
										<td>{percent}</td>
									</tr>
								))}
							</tbody>
						</Table>
					)
				}

				<AddDataModal/>
			</div>
		</div>
	)
}


const SingleClientGrid = ({clientId})=>{
	const user = useCurrentUser()
	const dispatch = useDispatch()
	const history = useHistory()

	//displayFormat = chart | table
	const [displayFormat,setDisplayFormat] = useState('graph')
	const client = useClient(clientId)

	const {
		status:clientsStatus,
		clients
	} = useClients()

	const {
		categoryGroups,
		filters,
		status,
		ids,
	} = useFilteredClientMetricProgressData(clientId)


	const categories = useMetriceCategories()

	const handleChangeCategoryFilter = e => {
		dispatch(setFilters({category:e.target.value}))
	}

	const [printing,setPrinting] = useState(false)

	const handlePrint = () => {
		setPrinting(true)
		setTimeout(()=>{
			window.print()
			setPrinting(false)
		})
	}

	const toggleAddDataModal = useAddDataModalToggle()

	//map from category names to the coresponding
	//ai demo key
	const categoryNameAiDemoKeyMap = {
		'AI Knee Flexion Measurements':'knee-flexion',
		'AI Single Leg Balance Assessment':'balance',
		'AI Single Leg Squat Assessment':'single-leg-squat',
		'AI Squat Assessment':'squat',
		'AI Overhead Arm Mobility':'arm-overhead-movement'
	}

	return (
		<div style={{
			width:'100%',
			height:'100%',
			overflow:'hidden',
			display:'flex',
			flexFlow:'column',
			alignItems:'stretch'
		}}>
			<div style={{paddingBottom:'8px',borderBottom:'1px solid #ccc'}} className="pt-2 px-2 px-md-3">
				<div className="d-flex justify-content-between align-items-end flex-wrap">
					{user.account_type==='client'&&
						<strong>Your Metric Progress</strong>
					}
					{user.account_type!=='client'&&
						<div className="d-flex align-items-center">
							<UserThumbnail radius={50} src={client?.profile_pic}/>
							<div>
								<small>Client Name</small>
								<div style={{width:'200px'}}>
									<Select
										onChange={selected=>{
											history.replace(`/metric-graphs/?clientId=${selected.value}`)
										}}
										value={
											Boolean(client)
											? {label:client.user_name,value:client.user_id_number}
											: (clientId==='all'?{label:'All Clients',value:'all'}:null)
										}
										options={[
											{
												label:'All Clients',
												value:'all'
											},
											...clients.map(c=>({
												label:c.user_name,
												value:c.user_id_number
											}))
										]}
									/>
								</div>
							</div>
						</div>
					}
					<div className={css.HideDesktop}>
						<OverlayTrigger rootClose trigger="click" placement="bottom-end" overlay={
							<Popover>
								<Popover.Title>Options</Popover.Title>
								<Popover.Content>
									<div>
										<small className={"d-block text-center"}>
											Select metric category
										</small>
										<Form.Control
											onChange={handleChangeCategoryFilter}
											value={filters.category}
											as="select"
											size="sm"
										>
											<option value="all">All</option>
											{categories.map(cat=>(
												<option value={cat.category_id}>
													{cat.name}
												</option>
											))}
										</Form.Control>
									</div>
									<div>
										<small className="d-block text-center">
											Display Format
										</small>
										<ButtonGroup size="sm">
											<Button 
												variant={displayFormat==='graph'?'primary':'outline-primary'}
												onClick={()=>{ setDisplayFormat('graph') }}
											>
												Graph
											</Button>
											<Button 
												variant={displayFormat==='table'?'primary':'outline-primary'}
												onClick={()=>{ setDisplayFormat('table') }}
											>
												Table
											</Button>
											<Button 
												variant={displayFormat==='animations'?'primary':'outline-primary'}
												onClick={()=>{ setDisplayFormat('animations') }}
											>
												Animations
											</Button>
										</ButtonGroup>
									</div>
									<div>
										<DateRangeOptions/>
									</div>
								</Popover.Content>
							</Popover>
						}>
							<Button variant="outline-primary" size="sm">
								Options <i className="fas fa-sliders-h"/>
							</Button>
						</OverlayTrigger>
					</div>
					<div className={[css.NoPrint,css.HideMobile].join(' ')}>
						<small className={"d-block text-center"}>
							Select metric category
						</small>
						<Form.Control
							onChange={handleChangeCategoryFilter}
							value={filters.category}
							as="select"
							size="sm"
						>
							<option value="all">All</option>
							{categories.map(cat=>(
								<option value={cat.category_id}>
									{cat.name}
								</option>
							))}
						</Form.Control>
					</div>
					<div className={[css.NoPrint,css.HideMobile].join(' ')}>
						<small className="d-block text-center">
							Display Format
						</small>
						<ButtonGroup size="sm">
							<Button 
								variant={displayFormat==='graph'?'primary':'outline-primary'}
								onClick={()=>{ setDisplayFormat('graph') }}
							>
								Graph
							</Button>
							<Button 
								variant={displayFormat==='table'?'primary':'outline-primary'}
								onClick={()=>{ setDisplayFormat('table') }}
							>
								Table
							</Button>
							<Button 
								variant={displayFormat==='animations'?'primary':'outline-primary'}
								onClick={()=>{ setDisplayFormat('animations') }}
							>
								Animations
							</Button>
						</ButtonGroup>
					</div>
					<div className={[css.NoPrint,css.HideMobile].join(' ')}>
						<DateRangeOptions/>
					</div>
					<ButtonGroup 
						className={
							[css.NoPrint,"mt-2"].join(' ')
						} 
						size="sm"
					>
						<Button
							disabled={status==='pending'}
							onClick={toggleAddDataModal}
							variant="outline-success"
						>
							Add Progress Data
						</Button>
						<Button 
							variant="outline-secondary"
							onClick={handlePrint}
						>
							<i className="fa fa-print"/>
						</Button>
					</ButtonGroup>
				</div>
				{(user.account_type!=='client'||user.edit_permissions.assessmentList==='1')&&
					<div className={[css.NoPrint,"mt-2 text-right"].join(' ')}>
						<Link to={`/metricList?clientId=${clientId}`} href="#">
							<small className="d-inline-block">
								Change which metrics are measured
							</small>
						</Link>
					</div>
				}
			</div>
			<div style={{
				height:'100%',
				overflow:'auto',
				paddingBottom:'200px'
			}}>
				{displayFormat==='graph'&&
					<div className={["d-flex align-items-center mt-2 flex-wrap px-2 px-md-3",css.NoPrint].join(' ')}>
						<strong className="mr-2">Tip:</strong>
						Mouse over datapoints like this <span style={{
							border:'1px solid #1f1f1f',
							borderRadius:'20px',
							background:'#fff',
							width:'12px',
							height:'12px',
							display:'inline-block',
							margin:'0 8px'
						}}/> to view notes
					</div>
				}
				{
					status==='pending'
					? <div className="p-3 text-center"><Spinner variant="primary" animation="border"/></div>
					: categoryGroups.map(g=>(
						<div key={g.id} style={{borderBottom:'1px solid #eee'}} className="pb-4">
							<div className="text-center my-3">
								<span style={{
									background:'#000C2D',
									color:'#fff',
									fontSize:'20px',
									padding:'8px 24px',
									borderRadius:'100px'
								}}>
									{g.name}
								</span>
							</div>
							<div className={
								(printing&&css.PrintLayout)
								||
								(displayFormat === 'graph'?css.GraphGrid:css.TableGrid)
							}>
								{displayFormat!=='animations'&&g.metrics.map( id => (
									(displayFormat === 'graph'&&
										(
											printing
											? <PrintableProgressGraph key={id} id={id}/>
											: <ProgressGraph key={id} id={id} />
										)
									)
									||
									(displayFormat === 'table'&&
										<ProgressTable key={id} id={id} />
									)
								))}
								{displayFormat==='animations'&&
									<LogsViewer
										demo={categoryNameAiDemoKeyMap[g.name]}
										aiLogs={g.aiLogs}
										size={512}
									/>
								}
							</div>
						</div>
					))
				}
				<AddDataModal/>
			</div>
		</div>
	)
}

const Grid = ({location})=>{
	
	
	//get url search params
	const params = new URLSearchParams(location.search)
	
	//julia id = 17069635
	const clientId = params.get('clientId')

	return (
		clientId === 'all'
		? <AggregateGrid/>
		: <SingleClientGrid clientId={clientId}/>
	)
}

export default Grid